

















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import MaterialFormLineItem from '@/classes/MaterialFormLineItem';
import MaterialItem from '@/classes/MaterialItem';

@Component
export default class MaterialItemFormTable extends Vue {
    @Prop() public formItemList!: MaterialFormLineItem[];
    @Prop({default: false}) public view!: boolean;

    public get formItemListPlusDetails(): MaterialFormLineItem[] {
        return this.formItemList.map((item: MaterialFormLineItem) => {
            if (item.businessCard && this.view) {
                item._showDetails = true;
                return item;
            } else {
                return item;
            }
        });
    }

    public getItemName(formItem: MaterialFormLineItem): string {
        const materialItem: MaterialItem | undefined = this.$store.getters['material/getMaterialItemById'](formItem.materialItemId);
        if (materialItem !== undefined && materialItem.listItem !== undefined && materialItem.quantityOfStock !== undefined) {
            return materialItem.listItem + ' (QTY ' + materialItem.quantityOfStock + ')';
        } else {
            return materialItem && materialItem.listItem ? materialItem.listItem : '';
        }
    }

    get fields() {
        return [{
            key: 'item',
            label: 'Item'
        }, {
            key: 'quantity',
            label: 'Qty'
        }, {
            key: 'action',
            label: ''
        }];
    }

    public removeFromForm(formItem: MaterialFormLineItem): void {
        const index: number = this.formItemList.findIndex((fItem: MaterialFormLineItem) => fItem.materialItemId === formItem.materialItemId);
        if (index > -1) {
            this.formItemList.splice(index, 1);
        }
    }
}
